export const queryKeys = {
  jobs: {
    all: ["jobs"] as const,
    detail: (id: string) => ["job", id] as const,
    activity: (id: string) => ["job-activity", id] as const,
    similar: (id: string) => ["similar-jobs", id] as const,
  },
  applications: {
    all: ["applications"] as const,
    detail: (id: string) => ["application", id] as const,
    status: (jobId: string) => ["applications", "status", jobId] as const,
    activity: (id: string) => ["application-activity", id] as const,
    jobApplication: (jobId: string, appId: string) =>
      ["job-application", jobId, appId] as const,
  },
  marketplace: {
    nearby: (params?: unknown) =>
      params ? (["nearbyjobs", params] as const) : (["nearbyjobs"] as const),
  },
  favourites: {
    all: ["favourites"] as const,
    status: (jobId: string) => ["favourites", "status", jobId] as const,
  },
  resumes: {
    all: ["resumes"] as const,
    detail: (id: string) => ["resume", id] as const,
  },
  conversations: {
    all: ["conversations"] as const,
    detail: (id: string) => ["conversation", id] as const,
    messages: (id: string) => ["get-messages", id] as const,
    participant: (id: string) => ["get-participant", id] as const,
  },
  userCvs: {
    all: ["user-cvs"] as const,
  },
  notifications: {
    inbox: ["notifications", "inbox"] as const,
    archive: ["notifications", "archive"] as const,
    preferences: ["notification-preferences"] as const,
  },
  account: {
    user: ["account/get-authenticated-user"] as const,
    authMethods: ["account/user/get-auth-methods"] as const,
    organizations: ["account/get-organizations"] as const,
    organization: ["account/get-organization"] as const,
    stores: ["account/get-organization-stores"] as const,
    members: ["account/get-organization-members"] as const,
    permissions: ["account/get-organization-permissions"] as const,
  },
  vetting: {
    status: ["vetting-status"] as const,
  },
  ai: {
    suggestions: ["ai/improve-description-suggestions"] as const,
    screeningQuestions: (jobId: string) =>
      ["ai/screening-questions", jobId] as const,
  },

  admin: {
    stats: ["admin-stats"] as const,
    users: (params?: Record<string, unknown>) =>
      params ? (["admin-users", params] as const) : (["admin-users"] as const),
    userDetail: (id: string) => ["admin-user", id] as const,
    organizations: (params?: Record<string, unknown>) =>
      params
        ? (["admin-organizations", params] as const)
        : (["admin-organizations"] as const),
    organizationDetail: (id: string) => ["admin-organization", id] as const,
    organizationStores: (id: string) =>
      ["admin-organization-stores", id] as const,
    jobs: (params?: Record<string, unknown>) =>
      params ? (["admin-jobs", params] as const) : (["admin-jobs"] as const),
    jobDetail: (id: string) => ["admin-job", id] as const,
    applications: (params?: Record<string, unknown>) =>
      params
        ? (["admin-applications", params] as const)
        : (["admin-applications"] as const),
    applicationDetail: (id: string) => ["admin-application", id] as const,
    invites: (params?: Record<string, unknown>) =>
      params
        ? (["admin-invites", params] as const)
        : (["admin-invites"] as const),
    vettings: (params?: Record<string, unknown>) =>
      params
        ? (["admin-vettings", params] as const)
        : (["admin-vettings"] as const),
    vettingDetail: (id: string) => ["admin-vetting", id] as const,
    omnicheckStats: ["admin-omnicheck-stats"] as const,
    twilioCredits: ["admin-twilio-credits"] as const,
    usageSummary: (params?: Record<string, unknown>) =>
      params
        ? (["admin-usage-summary", params] as const)
        : (["admin-usage-summary"] as const),
    usageEvents: (params?: Record<string, unknown>) =>
      params
        ? (["admin-usage-events", params] as const)
        : (["admin-usage-events"] as const),
    organizationUsageSummary: (id: string, params?: Record<string, unknown>) =>
      params
        ? (["admin-organization-usage-summary", id, params] as const)
        : (["admin-organization-usage-summary", id] as const),
  },
  auth: {
    qaLoginEnabled: ["auth/qa-login/enabled"] as const,
  },
  flags: {
    all: ["flags"] as const,
    pilotSelfServeLocked: ["flags/pilot-self-serve-locked"] as const,
  },
} as const;
